<template>
  <nav>
    <FleetwareLogo />
    <div class="main-navigaton-container" ref="mainMenuContainer">
      <a href="https://www.fleetware.hu/megoldasaink/">{{ $t('navigation.solutions') }}</a>
      <router-link :to="Routes.defaultPackageSelector()">{{ $t('navigation.packages') }}</router-link>
      <a href="https://www.fleetware.hu/hogyan-mukodik/" >{{ $t('navigation.how_it_works') }}</a>
      <a href="https://www.fleetware.hu/hirek/">{{ $t('navigation.news') }}</a>
      <a class="login" href="https://www.fleetware.hu/belepes/">{{ $t('navigation.login') }}</a>
    </div>
    <div class="mobile-menu-cart-container">
      <img class="mobile-hamburger-menu" @click="showMenu()" src="../../../public/img/burger.png">
      <cart></cart>
    </div>
  </nav>
</template>

<script>
import Cart from './Cart'
import FleetwareLogo from './FleetwareLogo'
import { Routes } from '../../order-wizard/utils/Routes'

export default {
  name: 'Navigation',
  components: {
    Cart,
    FleetwareLogo
  },

  data () {
    return {
      Routes
    }
  },

  methods: {
    showMenu () {
      this.$refs.mainMenuContainer.style.display === 'block' ? this.$refs.mainMenuContainer.style.display = 'none' : this.$refs.mainMenuContainer.style.display = 'block'
    }
  }
}
</script>

<style scoped lang="scss">
nav {
  width: 100%;
  height: 60px;
  line-height: 60px;
  text-align: center;

  a {
    height: 16px;
    font-family: 'Work Sans', sans-serif;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #37474f;
    margin: 0 24px;

    &.login {
      border-radius: 1px;
      border: solid 1.5px #599900;
      color: #599900;
      text-transform: uppercase;
      padding: 9px;
      font-weight: 600;
      letter-spacing: 1px;
    }
  }
}

.main-navigaton-container{
  display: inline-block;
}

.mobile-menu-cart-container{
  display: inline-block;
}

.mobile-hamburger-menu{
  display: none;
}

#smartcommerce_fleetware_cart {
  margin-left: 31px;
  vertical-align: middle;
}

/deep/ .fleetware-logo img {
  height: 60px;
  vertical-align: top;
  margin-right: 44px;
  left: -75px;
  position: relative;
}

@media(max-width: 1182px) {
  nav a {
    margin: 0 12px;
  }
}

@media(max-width: 1038px) {
  /deep/ .fleetware-logo img {
    left: 0;
  }

  nav a {
    margin: 0 6px;
  }
}

@media(max-width: 768px) {
  nav{
    height: 60px;
    text-align: left;
    position: fixed;
    top: 0;
    z-index: 3000;
    background-color: #FFF;
  }

  .main-navigaton-container{
    display: none;
    position: absolute;
    top: 60px;
    width: 100%;
    border: 1px solid #599900;
  }

  .main-navigaton-container a{
    display: block;
    width: 100%;
    background-color: #FFF;
    border-bottom: 1px solid #599900;
    height: inherit;
    margin: 0px;
    padding: 20px 0px;
    color: #599900;
    font-size: 16px;
  }

  .main-navigaton-container a.login{
    border: 0px;
    padding: 15px 0px;
    background-color: #599900;
    color: #FFF;
  }

  .mobile-menu-cart-container{
    float: right;
    text-align: center;
  }

  .mobile-hamburger-menu{
    display: inline-block;
    width: 40px;
    border-radius: 5px;
    transition: 0.5s;
  }

  .mobile-hamburger-menu:active{
    background-color: #bbb;
  }
}
</style>
